import { render, staticRenderFns } from "./task-index.vue?vue&type=template&id=7834a49c"
import script from "./task-index.vue?vue&type=script&lang=js"
export * from "./task-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports